import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";
import { generateATSResume } from "@/lib/generateATSResume";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
export const ATSResumeDownload = () => {
  const [isGenerating, setIsGenerating] = useState(false);
  const {
    data: profile
  } = useQuery({
    queryKey: ["profile"],
    queryFn: async () => {
      const {
        data,
        error
      } = await supabase.from("profile").select("*").single();
      if (error) throw error;
      return data;
    }
  });
  const {
    data: experiences
  } = useQuery({
    queryKey: ["experiences"],
    queryFn: async () => {
      const {
        data,
        error
      } = await supabase.from("work_experience").select("*").order("display_order");
      if (error) throw error;
      return data;
    }
  });
  const {
    data: education
  } = useQuery({
    queryKey: ["education"],
    queryFn: async () => {
      const {
        data,
        error
      } = await supabase.from("education").select("*").order("display_order");
      if (error) throw error;
      return data;
    }
  });
  const {
    data: skills
  } = useQuery({
    queryKey: ["skills"],
    queryFn: async () => {
      const {
        data,
        error
      } = await supabase.from("skills").select("*").order("display_order");
      if (error) throw error;
      return data;
    }
  });
  const {
    data: competencies
  } = useQuery({
    queryKey: ["competencies"],
    queryFn: async () => {
      const {
        data,
        error
      } = await supabase.from("core_competencies").select("*").order("display_order");
      if (error) throw error;
      return data;
    }
  });
  const handleDownload = async () => {
    if (!profile) {
      toast.error("Profile data not loaded");
      return;
    }
    setIsGenerating(true);
    try {
      generateATSResume({
        profile,
        experiences: experiences || [],
        education: education || [],
        skills: skills || [],
        competencies: competencies || []
      });
      toast.success("Resume downloaded successfully!");
    } catch (error) {
      console.error("Error generating resume:", error);
      toast.error("Failed to generate resume");
    } finally {
      setIsGenerating(false);
    }
  };
  return (
    <Button
      onClick={handleDownload}
      disabled={isGenerating || !profile}
      className="rounded-full bg-primary hover:bg-primary/90 text-primary-foreground gap-2"
    >
      <Icon name="download" size={18} />
      {isGenerating ? "Generating..." : "Download Resume"}
    </Button>
  );
};